const validateMessages = {
    required: '${label} é obrigatório!',
};

export {validateMessages};
